let prefix = 'uu-glyphicon-';
export const alertCircle = `${prefix}alert-circle`;
export const arrowDown = `${prefix}arrow-down`;
export const arrowLeft = `${prefix}arrow-left`;
export const arrowRight = `${prefix}arrow-right`;
export const arrowUp = `${prefix}arrow-up`;
export const calendar = `${prefix}calendar`;
export const clock = `${prefix}clock`;
export const cross = `${prefix}cross`;
export const errorCircle = `${prefix}error-circle`;
export const finder = `${prefix}finder`;
export const flagUpload = `${prefix}flag-upload`;
export const menu = `${prefix}menu`;
export const minus = `${prefix}minus`;
export const ok = `${prefix}ok`;
export const okCircle = `${prefix}ok-circle`;
export const person = `${prefix}person`;
export const picture = `${prefix}picture`;
export const plus = `${prefix}plus`;
export const point = `${prefix}point`;
export const thumb = `${prefix}thumb`;



// WEBPACK FOOTER //
// ./environment/glyphicons.js